import { render } from "./EquipamentosSetoresTabPage.vue?vue&type=template&id=624fcbe1"
import script from "./EquipamentosSetoresTabPage.vue?vue&type=script&lang=js"
export * from "./EquipamentosSetoresTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__